(function() { window.GUID_d332c080_2925_4d9b_8559_3d06bc875273 = { getGuid: function() { return "d332c080-2925-4d9b-8559-3d06bc875273"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class NotificationsButton extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                try {
                    this.Log("Instantiating control...");
                    this.controlId = params[0];
                    this.isFollowing = params[1] == "True";
                    this.isSubscribed = params[2] == "True";
                    this.personaType = params[3];
                    this.personaId = params[4];
                    this.isLocked = params[5] == "True";
                    this.highlightedNotification = params[6];
                    this.textFormatWhenUnsubscribed = params[7] == "True";
                }
                catch (error) {
                    console.error("Error instantiating control.", error);
                }
            }
            OnBindEvents() {
                try {
                    this.Log("Binding events...");
                    this.$Control.offon(`click.${this.constructor.name}-clicked`, this.handleClick.bind(this));
                    this.Log("Events bound.");
                }
                catch (error) {
                    console.error("Error binding events.", error);
                }
            }
            OnDispose() { }
            OnControlRendered() {
                this.updateButtonState();
            }
            handleClick(e) {
                try {
                    this.Log("Handling click...");
                    if (this.isLocked) {
                        if (!this.isFollowing) {
                            this.Log("Control is locked and user is not following, aborting.");
                            const url = CS.Url.CSUrl("PlayerFeaturePopup");
                            if (!CS.Helper.isNullOrWhiteSpace(url)) {
                                this.Log("Showing player feature popup...");
                                Controls.Popup.ShowAjaxModal(url, {
                                    featureId: CS.Enumeration.PlayerFeatureId.FollowPlayersAndTeams,
                                }, ({ popup }) => {
                                    this.Log("Player feature popup shown.");
                                }, ({ popup }) => { }, true);
                            }
                            return;
                        }
                        this.Log("Control is locked, but user is following, continuing.");
                    }
                    this.showNotificationsPopup()
                        .then(() => {
                        if (this.followingStateChanged) {
                            requestAnimationFrame(() => {
                                CS.DOM.$body.trigger(`NotificationsButton.${NotificationsButton.EventNames.FollowingStateChanged}`, {
                                    personaId: this.personaId,
                                    isNowFollowing: this.isFollowing,
                                });
                            });
                        }
                    })
                        .catch((error) => {
                        throw error;
                    });
                }
                catch (error) {
                    console.error("Error handling click.", error);
                }
            }
            showNotificationsPopup() {
                return new Promise((resolve, reject) => {
                    try {
                        this.Log("Showing notifications popup...");
                        const url = CS.Url.CSUrl("FriendShowNotificationsModal");
                        if (CS.Helper.isNullOrWhiteSpace(url)) {
                            Controls.ScriptErrorLogger.DisplayError({
                                message: "Url is null or whitespace.",
                                file: "NotificationsButton.ts",
                            });
                            throw new Error("Url is null or whitespace.");
                        }
                        const data = {
                            friendPersonaId: this.personaId,
                            highlightedNotification: this.highlightedNotification,
                        };
                        Controls.Popup.ShowAjaxModal(url, data, ({ popup }) => {
                            this.Log("Notifications popup shown.");
                            const popupId = popup.ControlId;
                            let notificationsModalId = "";
                            if (popupId.indexOf("popup-") === 0) {
                                notificationsModalId = popupId.substring(6);
                            }
                            if (CS.Helper.isNullOrWhiteSpace(notificationsModalId)) {
                                Controls.ScriptErrorLogger.DisplayError({
                                    message: "Unable to determine notifications modal id from popup id.",
                                    file: "NotificationsModal.ts",
                                });
                                throw new Error("Unable to determine notifications modal id from popup id.");
                            }
                            CS.Controls.NotificationsModal.Events.FollowedPersona({
                                selector: `#${notificationsModalId}`,
                                callback: (sender, e) => {
                                    this.Log("Executing callback from event 'FollowedPersona'...");
                                    this.isFollowing = true;
                                    this.followingStateChanged = true;
                                    this.updateButtonState();
                                },
                            });
                            CS.Controls.NotificationsModal.Events.UnfollowedPersona({
                                selector: `#${notificationsModalId}`,
                                callback: (sender, e) => {
                                    this.Log("Executing callback from event 'UnfollowedPersona'...");
                                    this.isFollowing = false;
                                    this.followingStateChanged = true;
                                    this.updateButtonState();
                                },
                            });
                            CS.Controls.NotificationsModal.Events.SubscribedToPersona({
                                selector: `#${notificationsModalId}`,
                                callback: (sender, e) => {
                                    this.Log("Executing callback from event 'SubscribedToPersona'...");
                                    this.isSubscribed = true;
                                    this.isFollowing = true;
                                    this.followingStateChanged = true;
                                    this.updateButtonState();
                                },
                            });
                            CS.Controls.NotificationsModal.Events.UnsubscribedFromPersona({
                                selector: `#${notificationsModalId}`,
                                callback: (sender, e) => {
                                    this.Log("Executing callback from event 'UnsubscribedFromPersona'...");
                                    this.isSubscribed = false;
                                    this.followingStateChanged = true;
                                    this.updateButtonState();
                                },
                            });
                        }, ({ popup }) => {
                            this.Log("Notifications popup closed.");
                            return resolve();
                        }, true);
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            updateButtonState() {
                if (this.isFollowing) {
                    this.$Control.addClass("is-following");
                    if (this.textFormatWhenUnsubscribed) {
                        this.$Control.removeClass("button");
                        this.$Control.removeClass("button--primary");
                        this.$Control.find(".icon-to-remove").hide();
                        this.$Control.find(".btn-label").hide();
                    }
                }
                else {
                    this.$Control.removeClass("is-following");
                    if (this.textFormatWhenUnsubscribed) {
                        this.$Control.addClass("button");
                        this.$Control.addClass("button--primary");
                        this.$Control.find(".icon-to-remove").show();
                        this.$Control.find(".btn-label").show();
                    }
                }
                if (this.isSubscribed) {
                    this.$Control.addClass("is-subscribed");
                }
                else {
                    this.$Control.removeClass("is-subscribed");
                }
            }
        }
        Controls.NotificationsButton = NotificationsButton;
        (function (NotificationsButton) {
            class Events {
                static FollowingStateChanged(param) {
                    Controls.RegisterEvent(Controls.FollowUnfollowButton, EventNames.FollowingStateChanged, param);
                }
            }
            NotificationsButton.Events = Events;
            class EventNames {
            }
            EventNames.FollowingStateChanged = "FollowingStateChanged";
            NotificationsButton.EventNames = EventNames;
        })(NotificationsButton = Controls.NotificationsButton || (Controls.NotificationsButton = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationsButton.js.map
